import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Styles
import './DataList.scss'

export const DataList = ({ data, title, narrow, size, color }) => {
  // Filtered data
  const filtered = data.filter((x) => {
    if (x.hideOnEmpty && !x.value) {
      return false
    }

    if (x.hidden) {
      return false
    }

    return true
  })

  // Classes
  const classList = useMemo(() => {
    const list = ['--table']

    if (color) {
      list.push('is-color-' + color)
    }

    if (narrow) {
      list.push('is-narrow')
    }

    if (size) {
      list.push('is-size-' + size)
    }

    return list.join(' ')
  }, [color, narrow, size])

  return (
    <div className="x-datalist">
      <table className={classList}>
        <tbody>
          {title ? (
            <tr>
              <td colSpan={2} className="--title">
                {title}
              </td>
            </tr>
          ) : null}
          {filtered.map((item, index) => (
            <tr key={index} className={`--row ${item.break ? 'is-break' : ''}`}>
              <td>{item.label}</td>
              <td id={item.id}>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

DataList.propTypes = {
  title: PropTypes.string,
  narrow: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['primary', 'secondary']),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.node,
      ]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.node,
      ]),
      break: PropTypes.bool,
      hidden: PropTypes.bool,
      hideOnEmpty: PropTypes.bool,
    })
  ),
}

DataList.defaultProps = {
  title: '',
  narrow: false,
  size: 'medium',
  color: 'primary',
  data: [],
}

export default DataList
